const ProductUpdateDateFormatter = (date: string) => {
  const createdDate = new Date(date)

  return (
    new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(createdDate.getTime())
  )
}

export default ProductUpdateDateFormatter
